import React, {useState} from "react";
import {IconButton, Menu, MenuItem, Stack, Typography} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";

interface TableHeaderProps {
    title?: React.ReactNode;
    controls?: React.ReactNode[];
    isMobile: boolean;
}

export const TableHeader: React.FC<TableHeaderProps> = ({
                                                            title,
                                                            controls,
                                                            isMobile,
                                                        }) => {
    const [controlsAnchorEl, setControlsAnchorEl] = useState<null | HTMLElement>(null);

    const handleControlsMenuClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setControlsAnchorEl(event.currentTarget);
    };

    const handleControlsMenuClose = () => {
        setControlsAnchorEl(null);
    };

    const isIconButton = (control: React.ReactNode) => {
        return React.isValidElement(control) && control.type === IconButton;
    };

    return (
        <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography component="h1" variant="h4">{title}</Typography>
            {controls && controls.length > 0 &&
                (isMobile ? (
                        <>
                            <Stack direction="row" spacing={2} alignItems="center">
                                {controls.filter(isIconButton)}
                                <IconButton onClick={handleControlsMenuClick}>
                                    <MoreVertIcon/>
                                </IconButton>
                            </Stack>
                            <Menu
                                anchorEl={controlsAnchorEl}
                                open={Boolean(controlsAnchorEl)}
                                onClose={handleControlsMenuClose}
                            >
                                <MenuItem>
                                    <Typography variant="h6">
                                        Ovládací prvky
                                    </Typography>
                                </MenuItem>
                                {controls
                                    .filter(control => !isIconButton(control))
                                    .map((control, index) => (
                                        <MenuItem key={index}>
                                            {control}
                                        </MenuItem>
                                    ))}
                            </Menu>
                        </>
                    ) : (
                        <Stack direction="row" spacing={2}>
                            {controls.map((control, index) => (
                                <div key={index}>{control}</div>
                            ))}
                        </Stack>
                    )
                )
            }
        </Stack>
    );
};

export default TableHeader;
